import { render, staticRenderFns } from "./LeakReasonTab.vue?vue&type=template&id=026c1cf4&scoped=true"
import script from "./LeakReasonTab.vue?vue&type=script&lang=ts"
export * from "./LeakReasonTab.vue?vue&type=script&lang=ts"
import style0 from "./LeakReasonTab.vue?vue&type=style&index=0&id=026c1cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026c1cf4",
  null
  
)

export default component.exports